<template>
	<div>
		<div class="text-end">
			<help helpId="step_5_help" title="Foglalás vége" text="A foglalás díjbekérőjét kiküldtük emailben"></help>
		</div>
		<NoRecords main_icon="fa fa-calendar-check" check title="Sikeres foglalás" subtitle="Visszaigazoló email üzenetünkön keresztül könnyen kifizetheti foglalását, kérjük nézze meg levelezőjét."></NoRecords>
		<div class="text-center">
			<button class="btn btn-primary btn-xs mx-1" @click="restart"><i class="fa fa-calendar-plus"></i> Újat foglalok</button>
		</div>
	</div>
</template>

<script>
import NoRecords from "../../components/NoRecords";
export default {
	components:{
		NoRecords
	},
  data(){
		return {
	}},
  methods: {
    restart() {
			this.$emit('restart');
    },
  }

}
</script>
